export default __webpack_public_path__ + "static/media/checkedCopy.4d4657e9.svg";